import { Injectable } from '@angular/core';
import { EntityState, EntityStore, StoreConfig } from '@datorama/akita';
import { MaterialRule } from 'src/app/models/MaterialRule.model';


export interface MaterialRuleState extends EntityState<any> {
  finalProductId: number | null;
}

@Injectable({ providedIn: 'root' })
@StoreConfig({ name: 'material-rule' })
export class MaterialRuleStore extends EntityStore<MaterialRuleState> {
  constructor() {
    super({ finalProductId: null });
  }
}
